import { FunctionComponent, useEffect } from 'react';
import styles from './BankLogin.module.scss';
import useDataFetchIndicator from '../../../../hooks/useDataFetchIndicator';

type FiservProps = {
  accessToken: string;
  FIID: string | undefined;
};

const FiservContainer: FunctionComponent<FiservProps> = ({ accessToken, FIID }) => {
  const fiservReturnUrl = import.meta.env.VITE_FISERV_RETURN_URL;
  const fiservApiUrl = import.meta.env.VITE_FISERV_API_URL;
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  // fiserv request
  useEffect(() => {
    if (accessToken !== undefined) {
      const form = document.getElementById('fiservForm');
      if (form) {
        const tempInput = document.createElement('input');
        tempInput.type = 'submit';
        tempInput.style.display = 'none';

        form.appendChild(tempInput);
        tempInput.click();

        form.removeChild(tempInput);
      } else {
        console.error('Form element not found');
      }
    }
  }, [accessToken]);

  useEffect(() => {
    setDataFetchingInfo(true, '', 'fullScreen');
  }, []);

  return (
    <>
      <form className={styles.form} id="fiservForm" action={fiservApiUrl} method="POST" target="fiserv_bank_connection">
        <p>
          <input name="sessionToken" maxLength={52} value={accessToken} />
          <input name="return_url" maxLength={250} value={`${fiservReturnUrl}/connnect/fiserv/success`} />
          <input name="fi_id" maxLength={10} value={FIID === '0' || FIID === null ? '505003' : String(FIID)} />
          <input name="error_url" maxLength={250} value={`${fiservReturnUrl}/connect/fiserv/error`} />
          <input name="css_url" maxLength={250} value={`${fiservReturnUrl}/fiserv.css`} />
        </p>
      </form>
      <iframe
        onLoad={() => setDataFetchingInfo(false)}
        name="fiserv_bank_connection"
        className={styles.BankFrame}
        title="Bank Login"
        src=""
        seamless
      />
    </>
  );
};

export default FiservContainer;
